// src/features/owner/sections/users/BannedUsersSection.tsx
import { useOwnerUsers } from '@/hooks';
import { useSession } from '@/hooks/useSession';
import { useOwnerAction } from '@/hooks/useOwnerAction';
import { Button } from '@/ui';
import { OwnerPanel, DataTable } from '../../components';
import type { Column } from '../../components';
import type { OwnerUserRow } from '@/core/models';

export function BannedUsersSection() {
  const { data, loading, error, refetch } = useOwnerUsers('', '', 'banned');
  const action = useOwnerAction();
  const { isSuperuser } = useSession();

  const columns: Column<OwnerUserRow>[] = [
    {
      key: 'handle',
      header: 'User',
      sortBy: (r) => r.handle,
      render: (r) => `${r.name} ${r.handle}`,
    },
    {
      key: 'actions',
      header: '',
      // Unban is superuser-only (backend is IsSuperuser-gated); hide the control otherwise.
      render: (r) =>
        isSuperuser ? (
          <Button
            variant="ghost"
            onClick={async () => {
              await action.unban(r.id);
              refetch();
            }}
          >
            Unban
          </Button>
        ) : null,
    },
  ];

  if (loading) return <p style={{ opacity: 0.6 }}>Loading…</p>;
  return (
    <OwnerPanel title="Banned users">
      <DataTable<OwnerUserRow>
        columns={columns}
        rows={data ?? []}
        rowKey={(r) => r.id}
        emptyIcon="ban"
        emptyMessage={error ?? 'No banned users'}
      />
    </OwnerPanel>
  );
}
